// const HOST = 'http://35.154.4.154/urxprt_live/web/v0_1/api/';
// const HOST = "http://35.154.4.154/urxprt_new/web/v0_1/api/";
const HOST = process.env.REACT_APP_API_BASEURL;

export const getLocalToken = () => {
  const token = localStorage.getItem("urexperttoken");

  if (token) {
    return token;
  }
};

export const getHost = () => {
  return HOST;
};

export const getHeaders = (url) => {
  let headers = {
    "Content-Type": "application/json",
    "Accept-Language": "en",
    crossDomain: "true",
  };
  return headers;
};
